/* eslint eqeqeq: "off" */
import Log from "pages/common/lib/grabyo-log";

export const PERMSTORE_ID = {
    SELECTED_STREAM: `stream`,
    SELECTED_STREAMS: `streams`,
    SELECTED_CAMPAIGN: `context`
};

const Persistence = {
    /*******************************************
     * Public Constants
     *******************************************/

    EXPIRES_NEVER: -1,
    EXPIRES_SHORT: 900000, // 15 Mins
    EXPIRES_MED: 1800000, // 30 Mins
    EXPIRES_LONG: 3600000, // 60 Mins

    PermStore: {
        fallbackDataStore: {},

        isExpired: function (pData) {
            Log.verbose(this, `isExpired called : [expires:${pData.expires}]`);

            if (pData.expires == undefined || pData.expires == -1) {
                return false;
            } else {
                return pData.expires <= new Date().getTime();
            }
        },

        isLocalStorageWritable: function () {
            try {
                localStorage.setItem(`isStorageWritable`, 1);
                localStorage.removeItem(`isStorageWritable`);
                return true;
            } catch (e) {
                return false;
            }
        },

        loadDataFromLocalStorage: function () {
            Log.verbose(this, `loadDataFromLocalStorage called`);

            if (
                typeof Storage !== `undefined` &&
                this.isLocalStorageWritable()
            ) {
                if (localStorage.getItem(`grabyoLS`) != null) {
                    return JSON.parse(localStorage.getItem(`grabyoLS`));
                } else {
                    return {};
                }
            } else {
                return this.fallbackDataStore;
            }
        },

        saveDataToLocalStorage: function (dataString) {
            Log.verbose(
                this,
                `saveDataToLocalStorage called : [dataString:${dataString}]`
            );

            if (
                typeof Storage !== `undefined` &&
                this.isLocalStorageWritable()
            ) {
                localStorage.setItem(`grabyoLS`, JSON.stringify(dataString));
            } else {
                this.fallbackDataStore = dataString;
            }
        },

        get: function (pKey) {
            Log.verbose(this, `get called : [pKey:${pKey}]`);

            // Step 1 : Load the data from the localStorage

            var data = this.loadDataFromLocalStorage();

            // Step 2 : Check for existence

            if (data == undefined) {
                Log.verbose(this, `Persistent Data DOES NOT exist`);
            } else {
                if (pKey == undefined) {
                    return data;
                } else if (data[pKey] == undefined) {
                    Log.verbose(this, `[Key:${pKey}] DOES NOT exist`);
                } else if (this.isExpired(data[pKey])) {
                    Log.verbose(
                        this,
                        `[Key:${pKey}] exists BUT expired : [${data[pKey].expires}]`
                    );
                    this.clear(pKey);
                } else {
                    return data[pKey].value;
                }
            }
        },

        set: function (pKey, pValue, pExpiresInMillis) {
            Log.verbose(
                this,
                `set called : [pKey:${pKey}] [pValue:${pValue}] [pExpiresInMillis:${pExpiresInMillis}]`
            );

            // Step 1 : Load the data from the localStorage

            var data = this.loadDataFromLocalStorage();

            // Step 2 : Check for existence and write to data

            if (data == undefined) {
                data = new Object();
            }

            if (data[pKey] != undefined && !this.isExpired(data[pKey])) {
                Log.verbose(
                    this,
                    `[Key:${pKey}] already exists and expires : [${data[pKey].expires}]. Overriding...`
                );
            }

            var valueWrapper = new Object();
            valueWrapper.value = pValue;
            valueWrapper.expires =
                pExpiresInMillis == undefined
                    ? this.EXPIRES_NEVER
                    : new Date().getTime() + pExpiresInMillis;

            data[pKey] = valueWrapper;

            // Step 3 : Save the data back to localStorage

            this.saveDataToLocalStorage(data);
        },

        clear: function (pKey) {
            Log.verbose(this, `clear called : [pKey:${pKey}]`);

            // Step 1 : Load the data from the localStorage

            var data = this.loadDataFromLocalStorage();

            // Step 2 : Check for existence and write to data

            if (data == undefined) {
                Log.verbose(this, `Persistent Data DOES NOT exist`);
            } else {
                if (pKey == undefined) {
                    // delete the entire data object - clear all
                    data = new Object();
                } else if (data[pKey] == undefined) {
                    Log.info(
                        this,
                        `Data with key : [${pKey}] can not be found. Unable to process clear()`
                    );
                } else if (this.isExpired(data[pKey])) {
                    Log.verbose(
                        this,
                        `[Key:${pKey}] exists BUT expired : [${data[pKey].expires}]. Deleting anyways`
                    );
                    delete data[pKey];
                } else {
                    // delete the data since it has been found
                    delete data[pKey];
                }

                // Step 3 : Save the data back to localStorage

                this.saveDataToLocalStorage(data);
            }
        }
    }
};

export default Persistence;
